import Collapsible from 'react-collapsible';
import { useFilter, useFilterDispatch } from '../../contexts/filter-context';
import { OrganizationItem } from '../organization-item';
import { Checkbox } from '../widgets/checkbox/checkbox';
import { Pane } from './pane';
import * as cn from 'classnames';
import { CollapsableContainerHeader } from '../widgets/collapsable-container-header/collapsable-container-header';

const phaseToMapColors = {
  1: '#fdba74', // Vulnerability
  2: '#6d28d9', // Exploitation
  3: '#a21caf', // Prevention
  4: '#0e7490', // Safety
  5: '#15803d', // Empowerment
  6: '#1d4ed8', // Prosecution
  7: '#2563eb', // Policy
};
// const phaseToMapColors = {
//   1: '#111A28', // Vulnerability
//   2: '#D9D78C', // Exploitation
//   3: '#BF7860', // Prevention
//   4: '#72231F', // Safety
//   5: '#437A75', // Empowerment
//   6: '#2B3545', // Prosecution
//   7: '#AFBFA2', // Policy
// };

export const GeographicOverviewPane = ({ ecosystemPhases: phases, visible }) => {
  console.log('phases = %o', phases);
  const state = useFilter();
  const dispatch = useFilterDispatch();

  const handlePhaseClicked = (phaseItem) => {
    // onEcosystemPhaseFiltersChange?.({ ...phaseItem, checked: !phaseItem.checked });
    dispatch({ type: 'phase-toggled', phaseId: phaseItem.ID });
  };

  return (
    <Pane visible={visible}>
      <div className="paneSection">
        <div className="paneTitle">Geographies</div>
        <div className="paneDescription">Select a phase below to show organizations on the map that are active in that phase</div>
      </div>
      <div className="paneSection">
        <Collapsible trigger={<CollapsableContainerHeader label="Phases" />} easing="ease" open={true}>
          {(phases || []).map((p) => (
            <Checkbox color={phaseToMapColors[p.ID]} key={p.ID} checked={state.phaseIds.includes(p.ID)} onClick={() => handlePhaseClicked(p)}>
              {p.NAME}
            </Checkbox>
          ))}
        </Collapsible>
      </div>
    </Pane>
  );
};
